// Purge cache MSAL local (self-heal) — docs/standards/AUTH_ROBUSTNESS.md

type StorageLike = Storage;

function collectMsalKeys(storage: StorageLike): string[] {
  const keys: string[] = [];
  try {
    for (let i = 0; i < storage.length; i++) {
      const key = storage.key(i);
      if (key?.startsWith('msal.')) keys.push(key);
    }
  } catch {
    void 0;
  }
  return keys;
}

/** Supprime toutes les clés msal.* (localStorage + sessionStorage). */
export function purgeMsalStorage(
  local: StorageLike = localStorage,
  session: StorageLike = sessionStorage,
): string[] {
  const removed: string[] = [];
  for (const storage of [local, session]) {
    for (const key of collectMsalKeys(storage)) {
      try {
        storage.removeItem(key);
        removed.push(key);
      } catch {
        void 0;
      }
    }
  }
  return removed;
}

export function isKnownRedirectInteractionError(err: unknown): boolean {
  if (err && typeof err === 'object' && 'errorCode' in err) {
    const code = String((err as { errorCode?: string }).errorCode ?? '');
    if (code === 'interaction_in_progress') return true;
    if (/interaction/i.test(code)) return true;
  }
  const message = err instanceof Error ? err.message : String(err);
  if (/AADSTS50196/i.test(message)) return true;
  if (/client request loop/i.test(message)) return true;
  return false;
}
